import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { JsonLd } from '@/components/feature/JsonLd';
import { Link } from 'react-router-dom';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://17c.cn/' },
    { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://17c.cn/about' },
  ],
};

const aboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 17c.cn',
  description: '了解17c.cn的品牌故事、发展历程与核心优势。17c.cn是您信赖的一站式综合网络平台。',
  url: 'https://17c.cn/about',
  isPartOf: { '@type': 'WebSite', name: '17c.cn', url: 'https://17c.cn' },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '17c.cn 是什么平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '17c.cn 是一个一站式综合网络平台，提供科技、生活、娱乐、财经、教育、健康等多领域优质内容与服务，致力于为用户打造快速、安全、便捷的在线体验。',
      },
    },
    {
      '@type': 'Question',
      name: '如何访问 17c.cn 的最新内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以直接访问 17c.cn 官网浏览最新文章和资讯，也可通过订阅我们的新闻通讯，第一时间获取最新内容推送。',
      },
    },
    {
      '@type': 'Question',
      name: '17c.cn 的内容多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '17c.cn 的内容团队每天更新，确保您能够及时获取科技、生活、娱乐、财经等领域的最新资讯和深度文章。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在 17c.cn 上注册账号？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过 17c.cn 官网首页的注册入口，使用邮箱或手机号快速完成注册，享受更多个性化服务与专属功能。',
      },
    },
    {
      '@type': 'Question',
      name: '17c.cn 是否免费使用？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '17c.cn 的基础内容浏览和资讯服务完全免费。部分高级功能可能需要注册登录后使用。',
      },
    },
  ],
};

const stats = [
  { value: '500万+', label: '月活跃用户' },
  { value: '10万+', label: '优质文章' },
  { value: '6', label: '内容分类' },
  { value: '99.9%', label: '服务可用率' },
];

const teamMembers = [
  {
    name: '张明远',
    role: '创始人 & CEO',
    description: '连续创业者，拥有15年互联网行业经验，致力于打造中国领先的综合内容平台。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20modern%20office%20clean%20minimal%20background%20warm%20lighting%20confident%20expression%20business%20casual%20attire&width=200&height=200&seq=team-ceo-01&orientation=squarish',
  },
  {
    name: '李思涵',
    role: '首席技术官',
    description: '前知名互联网公司技术总监，专注于AI和大数据技术，带领团队打造智能化内容分发系统。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20modern%20office%20clean%20minimal%20background%20warm%20lighting%20smart%20confident%20tech%20style&width=200&height=200&seq=team-cto-02&orientation=squarish',
  },
  {
    name: '陈晓宇',
    role: '内容总监',
    description: '资深媒体人，曾任多家主流媒体主编，对内容品质有着极致的追求和敏锐的判断力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20creative%20office%20clean%20minimal%20background%20warm%20lighting%20casual%20creative%20style&width=200&height=200&seq=team-editor-03&orientation=squarish',
  },
  {
    name: '刘芳华',
    role: '运营副总裁',
    description: '拥有丰富的用户增长和社区运营经验，曾带领团队实现千万级用户增长。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20modern%20office%20clean%20minimal%20background%20warm%20lighting%20elegant%20professional%20style&width=200&height=200&seq=team-ops-04&orientation=squarish',
  },
];

const milestones = [
  { year: '2020', title: '平台创立', description: '17c.cn 正式上线，以"连接世界，发现精彩"为使命，开启内容服务新征程。' },
  { year: '2021', title: '快速成长', description: '月活用户突破100万，内容覆盖科技、生活、娱乐三大领域。' },
  { year: '2022', title: '品类拓展', description: '新增财经、教育、健康三大内容分类，平台月活用户突破300万。' },
  { year: '2023', title: '技术升级', description: '引入AI智能推荐系统，个性化内容分发准确率提升至92%，用户体验大幅优化。' },
  { year: '2024', title: '行业领先', description: '月活用户突破500万，成为中文互联网最具影响力的综合内容平台之一。' },
  { year: '2025', title: '生态构建', description: '构建创作者生态体系，汇聚超过5000名优质内容创作者，日均发布文章超1000篇。' },
  { year: '2026', title: '智能时代', description: '全面升级AI驱动的内容平台，推出个性化订阅、智能摘要等创新功能，持续引领行业发展。' },
];

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <JsonLd data={breadcrumbSchema} />
      <JsonLd data={aboutPageSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main className="min-h-screen pt-16">
        {/* Breadcrumb */}
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </nav>
        </div>

        {/* Hero */}
        <section className="w-full bg-background-100 py-16 md:py-24">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-5">关于 17c.cn</h1>
            <p className="text-base md:text-lg text-foreground-600 max-w-[700px] mx-auto leading-relaxed">
              17c.cn 创立于2020年，致力于打造中文互联网最值得信赖的一站式综合网络平台。
              我们以"连接世界，发现精彩"为使命，
              通过优质内容与智能技术，为数百万用户提供快速、安全、便捷的在线服务体验。
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-6 rounded-lg bg-background-100">
                  <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{stat.value}</p>
                  <p className="mt-2 text-sm text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-[800px] mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">品牌故事</h2>
              <div className="space-y-6 text-sm md:text-base text-foreground-700 leading-relaxed">
                <p>
                  2020年，一群怀揣梦想的互联网人聚集在一起，他们看到了中文互联网内容生态中的巨大机遇——用户需要一个真正值得信赖的综合信息平台，一个能够聚合优质内容、提供便捷服务的一站式入口。
                </p>
                <p>
                  从最初几个人的小团队，到如今拥有数百名员工的行业领先企业，17c.cn 始终坚守"用户第一、内容为王"的初心。我们深知，在信息爆炸的时代，真正有价值的是对内容的精心筛选和对用户体验的不懈追求。
                </p>
                <p>
                  六年砥砺前行，17c.cn 已从单一的内容聚合平台发展成为覆盖科技、生活、娱乐、财经、教育、健康六大领域的综合网络平台。我们的AI智能推荐系统每天为数百万用户精准推送他们最关心的内容，我们的创作者生态聚集了超过5000名优质内容生产者。
                </p>
                <p>
                  展望未来，17c.cn 将继续坚持技术创新和内容深耕，以人工智能和大数据技术为驱动，为用户打造更加个性化、智能化的信息服务体验。我们相信，科技的力量能够让每个人更容易地发现世界的精彩。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">发展历程</h2>
            <div className="max-w-[800px] mx-auto">
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2"></div>
                {milestones.map((item, index) => (
                  <div
                    key={item.year}
                    className={`relative flex items-start gap-8 mb-10 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} hidden md:block`}>
                      <div className={`p-5 rounded-lg bg-background-100 ${index % 2 === 0 ? 'md:mr-4' : 'md:ml-4'}`}>
                        <p className="text-xs font-bold text-primary-500 mb-1">{item.year}</p>
                        <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                        <p className="mt-1 text-xs text-foreground-600">{item.description}</p>
                      </div>
                    </div>
                    <div className="absolute left-4 md:left-1/2 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50 -translate-x-1/2 z-10"></div>
                    <div className="flex-1 md:hidden ml-10">
                      <div className="p-5 rounded-lg bg-background-100">
                        <p className="text-xs font-bold text-primary-500 mb-1">{item.year}</p>
                        <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                        <p className="mt-1 text-xs text-foreground-600">{item.description}</p>
                      </div>
                    </div>
                    <div className="flex-1 md:hidden"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">核心团队</h2>
            <p className="text-sm text-foreground-600 text-center mb-10">一群热爱技术、追求卓越的互联网人</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {teamMembers.map((member) => (
                <div key={member.name} className="bg-background-50 rounded-lg p-6 text-center">
                  <div className="w-20 h-20 mx-auto rounded-full overflow-hidden bg-background-200">
                    <img src={member.imageUrl} alt={member.name} className="w-full h-full object-cover" />
                  </div>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-950">{member.name}</h3>
                  <p className="text-xs text-primary-500 mt-1">{member.role}</p>
                  <p className="mt-3 text-xs text-foreground-600 leading-relaxed">{member.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">联系我们</h2>
            <div className="max-w-[600px] mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h4 className="mt-4 text-sm font-semibold text-foreground-900">电子邮件</h4>
                <p className="mt-1 text-xs text-foreground-500">contact@17c.cn</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <h4 className="mt-4 text-sm font-semibold text-foreground-900">客服电话</h4>
                <p className="mt-1 text-xs text-foreground-500">400-xxx-xxxx</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-100">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h4 className="mt-4 text-sm font-semibold text-foreground-900">公司地址</h4>
                <p className="mt-1 text-xs text-foreground-500">中国北京</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">常见问题</h2>
            <div className="max-w-[700px] mx-auto space-y-4">
              {[
                { q: '17c.cn 是什么平台？', a: '17c.cn 是一个一站式综合网络平台，提供科技、生活、娱乐、财经、教育、健康等多领域优质内容与服务，致力于为用户打造快速、安全、便捷的在线体验。' },
                { q: '如何访问 17c.cn 的最新内容？', a: '您可以直接访问 17c.cn 官网浏览最新文章和资讯，也可通过订阅我们的新闻通讯，第一时间获取最新内容推送。' },
                { q: '17c.cn 的内容多久更新一次？', a: '17c.cn 的内容团队每天更新，确保您能够及时获取科技、生活、娱乐、财经等领域的最新资讯和深度文章。' },
                { q: '如何在 17c.cn 上注册账号？', a: '您可以通过 17c.cn 官网首页的注册入口，使用邮箱或手机号快速完成注册，享受更多个性化服务与专属功能。' },
                { q: '17c.cn 是否免费使用？', a: '17c.cn 的基础内容浏览和资讯服务完全免费。部分高级功能可能需要注册登录后使用。' },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-lg">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer text-sm font-medium text-foreground-900 list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}